/**
 * CODE_COMMENTS_160
 */
import { connect } from 'react-redux'

import { withTranslation } from 'react-i18next'
import BreadcrumbLinks from './components/BreadcrumbLinks'

import {
  getNamesOfOperateeCustomersInUrlPath,
  createBreadcrumbsDefinitions,
  createBreadcrumbsDefinitionsEmployee,
} from './util'

import { getIsEmployeePath } from '../../../utils'

const mapStateToProps = (state, props) => {
  let breadcrumbDefinitions

  const { currentPath, t: translate = a => a } = props
  const {
    router: { location },
  } = state
  const bookingDetailsBreadCrumbLabel = location?.state?.bookingBreadCrumbLabel

  if (getIsEmployeePath(currentPath)) {
    breadcrumbDefinitions = createBreadcrumbsDefinitionsEmployee(currentPath, {
      bookingBreadCrumbLabel: bookingDetailsBreadCrumbLabel,
      link: location.pathname,
    })
  } else {
    const namesofOperateeCustomers = getNamesOfOperateeCustomersInUrlPath(state, currentPath)
    breadcrumbDefinitions = createBreadcrumbsDefinitions(
      currentPath,
      namesofOperateeCustomers,
      translate
    )
  }
  return {
    breadcrumbDefinitions,
  }
}

export default withTranslation()(connect(mapStateToProps)(BreadcrumbLinks))
